import * as $ from 'jquery';

/**
 * Searches for the closest ancestor Ultra Document element. If any results are found,
 * it indicates that the given `container` is within an Enhanced (i.e. not legacy)
 * Ultra Document.
 */
export const getUltraDocumentContainer = (container: HTMLElement): JQuery<HTMLElement> => {
    return $(container).parents('.enhanced-ultra-documents');
};
